import _ from "lodash";

import { getLocalStorageUserProfile } from "./localStorage";

export const getUserExtraCustomers = () => {
  const userProfile = getLocalStorageUserProfile();
  const extraCustomers = _.chain(userProfile)
    .get(["userExtraCustomers"])
    .map((item) => item?.category_customer_id)
    .value();

  const defaultCustomer = _.get(userProfile, ["categoryCustomer", "id"], null);
  const allCustomers = _.isNil(defaultCustomer)
    ? null
    : [...extraCustomers, defaultCustomer];
  return allCustomers;
  // console.log("allCustomer :>> ", allCustomer);
  // console.log("extraCustomers :>> ", extraCustomers);
};
